<div class="d-flex flex-column min-vh-100">
    <app-header></app-header>

    <router-outlet></router-outlet>

    <app-footer></app-footer>
</div>